var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { computed, makeObservable } from 'mobx';
import { EntityMutation } from '../../../classes/entity/modules/EntityMutation';
export class MemorizePointsByHear extends EntityMutation {
    constructor(parent) {
        super(parent);
        makeObservable(this);
    }
    get question() {
        return this.parent;
    }
    get task_setInputByHear() {
        const remainingWordTasks = this.question.memorizePointsRemaining.remainingWordTasks;
        if (remainingWordTasks.length === 0)
            return undefined;
        const wordTask = this.question.memorizePointsRemaining.activeWordTask;
        if (!wordTask)
            return undefined;
        /*
    
        if (!wordTask.wordTaskHear.bestWordingGuess) return undefined;
        const inputString = wordTask.wordTaskHear.bestWordingGuess.guess.transcript;
        const exec = () => (wordTask.wordTaskInput.inputValue = inputString);
        return new Mutation({
          exec,
          owner: this.question
        });
        */
    }
    get activeMutations() {
        return [this.task_setInputByHear].filter(t => !!t);
    }
}
__decorate([
    computed
], MemorizePointsByHear.prototype, "task_setInputByHear", null);
__decorate([
    computed
], MemorizePointsByHear.prototype, "activeMutations", null);
